import * as React from 'react';
import AuthGoogleAccessForm from '../accounts/AuthGoogleAccessForm';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

interface ReauthorizeProviderModalProps {
  close: () => void;
  link: string;
  provider: 'Canvas' | 'Clever' | 'Google';
}

const ReauthorizeModal = ({ close, link, provider }: ReauthorizeProviderModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  function handleReauthorizeClick() {
    if (provider !== 'Google') { window.location.href = link; }
  }

  return (
    <div className='modal-container reauthorize-provider-modal-container'>
      <div className='modal-background' />
      <div
        aria-labelledby="reauthorizeProviderModalTitle"
        aria-modal="true"
        className='reauthorize-provider-modal quill-modal modal-body'
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className='title' id="reauthorizeProviderModalTitle">Reauthorize {provider}</h3>
        </div>
        <p>
          To import a new {provider} classroom, you need to reauthorize {provider} access.
          <br />
          Clicking reauthorize will re-direct you to {provider}.
        </p>
        <div className='form-buttons'>
          <button className='quill-button focus-on-light outlined grey medium' onClick={close} type='button'>
            Cancel
          </button>
          {provider === 'Google' ?
            <AuthGoogleAccessForm
              buttonClass='quill-button focus-on-light contained green medium'
              text='Reauthorize'
            />
            :
            <button
              className='quill-button focus-on-light contained green medium'
              onClick={handleReauthorizeClick}
              type='button'
            >
              Reauthorize
            </button>}
        </div>
      </div>
    </div>
  )
}

export default ReauthorizeModal
